
const state = {
  id: null,
  input_type: '',
  node_name: '',
  placeholder_text: '',
  publication_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'input_type' },
  { key: 'node_name' },
  { key: 'publication_id' },
  { key: 'title' },
]

export default state
